import { FormFieldContainer, FormLabel } from 'components/forms/FormComponents';
import styled from 'styled-components';
import { FONTSIZE, sizes, theme } from 'theme';

export type DropdownOption = {
    label: string;
    value: string;
};

type DropdownFieldProps = {
    id: string;
    labelText: string;
    options: DropdownOption[];
    value: string;
    onChange?: React.ChangeEventHandler<HTMLSelectElement>;
    required?: boolean;
};

export default function DropdownField({
    id,
    labelText,
    options,
    value,
    required = false,
    onChange,
}: DropdownFieldProps): JSX.Element {
    const labelId = `${id}-label`;

    return (
        <DropdownFieldContainer>
            <FormLabelWhite id={labelId} htmlFor={id}>
                {labelText}
                {required && ' *'}
            </FormLabelWhite>

            <Select id={id} aria-labelledby={labelId} value={value} onChange={onChange}>
                {options.map((option) => (
                    <Option key={option.value} value={option.value}>
                        {option.label}
                    </Option>
                ))}
            </Select>
        </DropdownFieldContainer>
    );
}

const FormLabelWhite = styled(FormLabel)`
    color: ${theme.textColourInverted};
`;

const DropdownFieldContainer = styled(FormFieldContainer)`
    display: flex;
    flex-direction: column;
    gap: ${sizes.spacingSm};
    padding-bottom: unset;
    width: 200px;
`;

const Select = styled.select`
    width: 100%;
    padding: ${sizes.spacingMd};
    font-family: ${theme.fontFamilyMain};
    font-size: ${FONTSIZE.BodyLarge};
    font-weight: 700;
    border-radius: ${sizes.spacingSm};
    border: 2px solid transparent;
    background: linear-gradient(90deg, #ead5ff 0%, #eddcff 100%);
    cursor: pointer;

    &:focus {
        background: ${theme.navigationBar.buttonFocusBackground};
        border: 2px solid ${theme.navigationBar.buttonFocusBorder};
        outline: ${theme.navigationBar.buttonFocusBorder};
    }
`;

const Option = styled.option`
    font-family: ${theme.fontFamilyMain};
    font-size: ${FONTSIZE.BodyLarge};
    font-weight: 700;
`;
